import React from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import './Layout.css';
import '../styles/yimnak-shell.css';

const WORKSPACE_PATHS = ['/disc', '/chat', '/pleadings'];

const Layout = ({ children }) => {
  const location = useLocation();
  const isWorkspacePage = WORKSPACE_PATHS.includes(location.pathname);
  const isChatPage = location.pathname === '/chat';

  return (
    <div
      className={`layout${isWorkspacePage ? ' layout--workspace' : ''}${isChatPage ? ' chat-layout' : ''}`}
    >
      <Header />
      <main className={`main-content${isChatPage ? ' chat-main-content' : ''}`}>
        {children}
      </main>
      {!isWorkspacePage ? <Footer /> : null}
    </div>
  );
};

export default Layout;
